import { navigate } from "gatsby";
import parse from "html-react-parser";
import React, { useEffect } from "react";
import PropTypes from "prop-types";

import {
  arrowLeft,
  callIcon,
  viewTickets,
} from "../../assets/images/icons";
import {
  onBackPressed,
  exitFromWebView,
  ingestData,
  isMobileBridgePresent,
  openURL,
  triggerNavigation,
  isWeb,
} from "../../bridges/BridgeServices";
import Chatbot from "../../components/Chatbot/Chatbot";
import useGetIVRDetails from "../../hooks/useGetIVRDetails";
import {
  EVENTS,
  OPEN_URL_ACTION_TYPE,
} from "../../utils/constants";
import { isTokenPresent } from "../../utils/cookieHelper";
import MobileContactSupport from "../MobileContactSupport/mobileContactSupport";
import SearchInput from "../SearchInput/searchInput";
import "./mobileHeader.scss";
import { getWaitText } from "../../utils/helperFunctions";
import { setFaqTitle } from "../../store/slices/common/common.setters";

const VIEW_TICKET_URL =
  "phonepe-wealth://app/help/viewTickets";

const MobileHeader = ({
  variant = "",
  faqTitle,
  data,
  isContactSupportVisible = false,
}) => {
  const ivrData = useGetIVRDetails();

  const handleTalkToUsOnClick = () => {
    openURL(
      `tel:${ivrData?.phoneNumber}`,
      "",
      OPEN_URL_ACTION_TYPE.CALL
    );
    ingestData({
      name: EVENTS.TALK_TO_US_CLICKED,
      data: {
        active: ivrData?.isEnabled,
        faqTitle,
      },
    });
  };

  const handleOnBackPress = () => {
    //TODO: Remove exitWebview and navigate(-1) when the adoption is 100%
    if (Freshbot.onBackPressed) {
      onBackPressed();
    } else if (Freshbot.exitWebview) {
      exitFromWebView();
    } else {
      //Adding this as a fallback in case any of the mobile bridges are not present.
      navigate(-1);
    }
  };

  const waitText = getWaitText(ivrData);

  useEffect(() => {
    setFaqTitle(
      { title: faqTitle },
      isContactSupportVisible
    );
  }, [location.pathname]);

  return (
    <>
      <div
        className={`mobile-header-container ${
          variant === "compressed"
            ? "compressed-mobile-header"
            : ""
        }`}
      >
        <div className="mobile-heading-wrapper">
          <div
            className="back-arrow"
            onClick={() => {
              handleOnBackPress();
            }}
          >
            {parse(arrowLeft)}
          </div>

          <p className="header-heading">Help Center</p>

          <SearchInput data={data} />
        </div>
        <Chatbot />
        {isTokenPresent() && variant !== "compressed" && (
          <>
            <div className="btn-wrapper">
              <div className="contact-support">
                <MobileContactSupport
                  supportBtnClassName={`${
                    isMobileBridgePresent()
                      ? "mobile-contact-support"
                      : "disabled-mobile-contact-support"
                  }`}
                  faqTitle={faqTitle}
                />
              </div>
              <div
                className="view-tickets"
                onClick={() => {
                  triggerNavigation({
                    deepLink: VIEW_TICKET_URL,
                  });
                  ingestData({
                    name: EVENTS.HELP_CENTER_VIEW_TICKET,
                  });
                }}
              >
                {parse(viewTickets)}
                <a
                  rel="noreferrer"
                  className="view-tickets-btn"
                >
                  View Tickets
                </a>
              </div>
            </div>

            {ivrData?.isEnabled && (
              <a
                onClick={() => handleTalkToUsOnClick()}
                className={`talk-to-us-wrapper ${
                  ivrData?.isAvailable ? "" : "disabled"
                }`}
              >
                {parse(callIcon)}
                <div className="talk-to-us-text-wrapper">
                  <p className="talk-to-us-text-header">
                    Talk To Us
                  </p>
                  {ivrData?.mobDesc ? (
                    <p className="talk-to-us-text-desc">
                      {ivrData.mobDesc}
                    </p>
                  ) : null}
                </div>
                {waitText ? (
                  <p className="talk-to-us-time-wrapper">
                    {waitText}
                  </p>
                ) : null}
              </a>
            )}
          </>
        )}
      </div>
    </>
  );
};

MobileHeader.propTypes = {
  variant: PropTypes.string,
  faqTitle: PropTypes.string,
};

export default MobileHeader;
